import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_ALL_APPLICATION_HR,
  APP_FILE_OFF_BOARDING,
  APP_FILE_ON_BORADING_LIST,
  APP_FILE_ON_BORADING_LISTS,
  APP_FILE_REQUEST_FORMS_LIST,
} from "./OnBoarding.constants";

const AllApplicationHr = Loadable(
  lazy(() =>
    import("./AllApplication/AllApplication").then(({ AllApplicationHR }) => ({
      default: AllApplicationHR,
    }))
  )
);
const OnBoardingList = Loadable(
  lazy(() =>
    import("./onBoardStep").then(({ OnBoardStep }) => ({
      default: OnBoardStep,
    }))
  )
);

const OffBoarding = Loadable(
  lazy(() =>
    import("./Offboarding/Offboarding").then(({ OffBoarding }) => ({
      default: OffBoarding,
    }))
  )
);
const RequestFormsList = Loadable(
  lazy(() =>
    import("./RequestForms/RequestFormsList").then(({ RequestFormsList }) => ({
      default: RequestFormsList,
    }))
  )
);

export const OnBoardingRoutes = [
  {
    path: `${APP_FILE_ALL_APPLICATION_HR}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_APPLICATION]}>
        <AllApplicationHr />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ON_BORADING_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_ONBOARDING]}>
        <OnBoardingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ON_BORADING_LIST}/:applicationNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_ONBOARDING]}>
        <OnBoardingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_ON_BORADING_LISTS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_ONBOARDING]}>
        <OnBoardingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_OFF_BOARDING}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_OFFBOARDING]}>
        <OffBoarding />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_REQUEST_FORMS_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HR_REQUEST_FORMS]}>
        <RequestFormsList />
      </AuthorizedRoute>
    ),
  },
];
